export const MOBILE_PAGE_SIZE = 10;

export interface PaginatedQueryParams {
  page: number;
  pageSize: number;
  filters?: Record<string, string | string[]>;
}

export function buildPaginatedQuery(params: PaginatedQueryParams): string {
  let query = '';
  if (params.page) query += `page=${params.page}&`;
  if (params.pageSize) query += `pageSize=${params.pageSize}&`;
  if (params.filters) {
    for (const [key, value] of Object.entries(params.filters)) {
      const serialized = Array.isArray(value) ? value.join(',') : value;
      if (serialized.length > 0) query += `${key}=${serialized}&`;
    }
  }
  return query;
}
